<template>
  <div class="modal-content-wrapper" v-if="dataUser" :class="{ ie: isIE }">
    <div class="modal-content">
      <div class="modal-header">
        <h5>{{ dataUser.entity.name }}</h5>
      </div>

      <div class="modal-body">
        <div class="container-fluid">
        <profession-form
          :dataUser="dataUser"
          :isManager="isManager"
          :currentUser="currentUser"
          :isSingleEntity="false"
          :small="true"
          :availableServices="servicesOptions"
          :availableHubs="hubsOptions"
          :availableOccupations="occupationsOptions"
          @change="onChange($event)"
        />
      </div>
</div>
      <div class="line">
        <p class="line-color"></p>
      </div>

      <div class="modal-footer">
        <div class="col-md-6 text-left">
          <button type="button" @click="cancelPopup" class="btn btn-default btn-cons m-t-10">
            {{ $t("SignUpForm.buttons.cancel") }}
          </button>
        </div>
        <div class="col-md-6 text-right">
          <button type="button" @click="confirmPopup" class="btn btn-primary btn-cons m-t-10">
            {{ $t("SignUpForm.buttons.validate") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from '@/lang'
  import { mapGetters } from "vuex";
  import ProfessionForm from './ProfessionForm';
  const { detect } = require('detect-browser');

  export default {
    name: "PopupValidationForm",
    data: function () {
      return {
        dataUser: null
      }
    },
    props: {
      dataAddOn: Object,
      currentUser: Object,
      addOns: Array,
      isManager: Boolean,
      availableServices: { type: Array, default: () => [] },
      availableOccupations: { type: Array, default: () => [] },
      availableHubs: { type: Array, default: () => [] }
    },
    components: { ProfessionForm },
    computed: {
      ...mapGetters({
        serverErrors: 'users/errors',
        hasErrors: 'users/hasErrors',
        manageableServicesOptions: 'users/manageableServices',
        manageableOccupationsOptions: 'users/manageableOccupations',
        manageableHubsOptions: 'users/manageableHubs',
      }),
      isIE() {
        if (detect()) {
          return detect().name == "ie"
        }
      },
      hubsOptions() {
        return this.availableHubs.length > 0 ? this.availableHubs : this.manageableHubsOptions
      },
      servicesOptions() {
        return this.availableServices.length > 0 ? this.availableServices : this.manageableServicesOptions
      },
      occupationsOptions() {
        return this.availableOccupations.length > 0 ? this.availableOccupations : this.manageableOccupationsOptions
      }
    },
    watch: {
      dataAddOn: function () {
        this.dataUser = Object.assign({}, this.dataAddOn)
      },
      dataUser: {
        handler(){
          if (this.dataUser.resource_type == 'extern') {
            this.dataUser.affiliated_service = null
          }
        },
        deep: true
      }
    },
    methods: {
      onChange(value) {
        this.dataUser = value
      },
      cancelPopup() {
        this.$store.commit('users/SET_ADDONS', this.addOns)
        this.$store.commit('users/SET_ADDON_POPUP_KEY')
        $('.popup-validation-form').modal('hide');
      },
      confirmPopup() {
        this.$validator.validateAll().then((result) => {
          if (result && !this.hasErrors) {
            let internalAddOns = [...this.addOns]

            for (let key in internalAddOns) {
              if (internalAddOns[key].entity.id == this.dataAddOn.entity.id) {
                internalAddOns[key] = this.dataUser
              }
            }
            this.$store.commit('users/SET_ADDONS', internalAddOns)
            this.$store.commit('users/SET_ADDON_POPUP_KEY')
            $('.popup-validation-form').modal('hide');
          }
        })
      }
    },
    mounted: async function () {
      this.dataUser = Object.assign({}, this.dataAddOn)
      await this.$store.dispatch('users/initManageableOptions', { entityId: this.dataAddOn.entity.id })
    }
  }
</script>

<style scoped>
  .line {
    padding: 0 25px;
  }

  .line-color {
    border-top: 1px solid rgba(0, 0, 0, 0.07);
  }

  .modal-content {
    border-radius: 10px;
  }

  .modal-header {
    padding: 15px 25px 5px 25px;
  }

  .modal-body {
    padding-bottom: 20px;
  }

  .ie .modal-content {
    max-width: 620px;
  }
  @media (max-width: 768px) {
    .modal.fade.slide-up.show .modal-dialog,
    .modal.fade.slide-up .modal-content-wrapper {
      display: block !important;
      width: 100%;
      width: 100vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/candidate/PopupValidationForm.vue